<template>
 <div class="website-stats">
 <el-card class="info-card" v-loading="loadingInfo" shadow="never">
 <div class="info-header">
 <div>
 <span class="info-name">{{ website.name }}</span>
 <el-tag :type="website.status ? 'success' : 'danger'" size="small" effect="light" style="margin-left:8px">
 {{ website.status ? '启用' : '禁用' }}
 </el-tag>
 </div>
 <div class="info-meta">
 <span class="info-tag"><i class="el-icon-link"></i> {{ website.domain }}</span>
 <span class="info-tag"><i class="el-icon-key"></i> {{ website.tracking_code }}</span>
 </div>
 </div>
 </el-card>

 <div class="filter-bar">
 <el-date-picker
 v-model="dateRange"
 type="daterange"
 range-separator="至"
 start-placeholder="开始日期"
 end-placeholder="结束日期"
 value-format="yyyy-MM-dd"
 :picker-options="pickerOptions"
 @change="loadAll"
 />
 <el-button type="primary" size="small" @click="loadAll" style="margin-left:12px">刷新</el-button>
 </div>

 <el-row :gutter="20" class="card-row">
 <el-col :span="6" v-for="card in overviewCards" :key="card.label">
 <div class="stat-card" :class="card.theme">
 <div class="stat-card-top">
 <div class="stat-card-icon"><i :class="card.icon"></i></div>
 <div class="stat-card-info">
 <div class="stat-card-value">{{ card.value }}</div>
 <div class="stat-card-label">{{ card.label }}</div>
 </div>
 </div>
 <div class="stat-card-sub">{{ card.sub || '\u00a0' }}</div>
 </div>
 </el-col>
 </el-row>

 <el-row :gutter="20" class="card-row">
 <el-col :span="16">
 <div class="chart-card">
 <div class="chart-header">
 <span class="chart-title">流量趋势</span>
 <el-select v-model="trendGranularity" size="small" style="width:90px" @change="onTrendGranularityChange">
 <el-option label="分" value="minute" />
 <el-option label="时" value="hour" />
 <el-option label="日" value="day" />
 <el-option label="周" value="week" />
 <el-option label="月" value="month" />
 <el-option label="年" value="year" />
 </el-select>
 </div>
 <div ref="trendChart" class="chart-body"></div>
 </div>
 </el-col>
 <el-col :span="8">
 <div class="chart-card">
 <div class="chart-header"><span class="chart-title">访问来源</span></div>
 <div ref="refererChart" class="chart-body"></div>
 </div>
 </el-col>
 </el-row>

 <el-row :gutter="20" class="card-row">
 <el-col :span="8">
 <div class="chart-card">
 <div class="chart-header"><span class="chart-title">浏览器分布</span></div>
 <div ref="browserChart" class="chart-body"></div>
 </div>
 </el-col>
 <el-col :span="8">
 <div class="chart-card">
 <div class="chart-header"><span class="chart-title">操作系统</span></div>
 <div ref="osChart" class="chart-body"></div>
 </div>
 </el-col>
 <el-col :span="8">
 <div class="chart-card">
 <div class="chart-header"><span class="chart-title">设备类型</span></div>
 <div ref="deviceChart" class="chart-body"></div>
 </div>
 </el-col>
 </el-row>

 <el-row :gutter="20" class="card-row">
 <el-col :span="24">
 <div class="chart-card">
 <div class="chart-header"><span class="chart-title">IP归属地分布</span></div>
 <div ref="locationChart" class="chart-body"></div>
 </div>
 </el-col>
 </el-row>

 <el-row :gutter="20" class="card-row">
 <el-col :span="24">
 <div class="chart-card">
 <div class="chart-header">
 <span class="chart-title">IP访问统计</span>
 <el-pagination
 @current-change="handleIpPageChange"
 :current-page="ipPage"
 :page-size="ipPageSize"
 :total="ipTotal"
 layout="total, prev, pager, next"
 style="float:right"
 />
 </div>
 <div class="filter-bar-inner">
 <el-input v-model="ipFilter.ip_keyword" placeholder="搜索IP" size="small" clearable style="width:140px" @keyup.enter.native="searchIp" />
 <el-input v-model="ipFilter.location_keyword" placeholder="搜索归属地" size="small" clearable style="width:140px" @keyup.enter.native="searchIp" />
 <el-select v-model="ipFilter.browser_filter" placeholder="浏览器" size="small" clearable style="width:120px">
 <el-option v-for="b in filterOptions.browsers" :key="b" :label="b" :value="b" />
 </el-select>
 <el-select v-model="ipFilter.os_filter" placeholder="操作系统" size="small" clearable style="width:120px">
 <el-option v-for="o in filterOptions.oses" :key="o" :label="o" :value="o" />
 </el-select>
 <el-select v-model="ipFilter.device_filter" placeholder="设备" size="small" clearable style="width:100px">
 <el-option v-for="d in filterOptions.devices" :key="d" :label="d" :value="d" />
 </el-select>
 <el-button type="primary" size="small" @click="searchIp">筛选</el-button>
 <el-button size="small" @click="resetIpFilter">重置</el-button>
 </div>
 <el-table :data="ipList" stripe size="small" style="width:100%">
 <el-table-column type="index" label="#" width="60" />
 <el-table-column prop="ip" label="IP地址" width="160" />
 <el-table-column prop="ip_location" label="归属地" width="160" />
 <el-table-column prop="browser" label="浏览器" width="100" />
 <el-table-column prop="os" label="操作系统" width="100" />
 <el-table-column prop="device" label="设备" width="80" />
 <el-table-column prop="visit_count" label="访问次数" width="100" sortable />
 <el-table-column prop="last_visit" label="最后访问时间" min-width="180">
 <template slot-scope="{row}">{{ formatTime(row.last_visit) }}</template>
 </el-table-column>
 </el-table>
 </div>
 </el-col>
 </el-row>
 </div>
</template>

<script>
import * as echarts from 'echarts';
import { websiteApi, statsApi } from '../api';
import dayjs from 'dayjs';

export default {
 name: 'WebsiteStats',
 data() {
 return {
 websiteId: this.$route.params.id,
 website: {},
 loadingInfo: false,
 dateRange: [dayjs().subtract(30, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
 overview: {},
 ipList: [],
 ipPage: 1,
 ipPageSize: 20,
 ipTotal: 0,
 ipFilter: { ip_keyword: '', location_keyword: '', browser_filter: '', os_filter: '', device_filter: '' },
 filterOptions: { browsers: [], oses: [], devices: [] },
 trendGranularity: 'day',
 charts: {},
 pickerOptions: {
 shortcuts: [
 { text: '今天', onClick(picker) { const d = dayjs().format('YYYY-MM-DD'); picker.$emit('pick', [d, d]); } },
 { text: '近7天', onClick(picker) { picker.$emit('pick', [dayjs().subtract(6, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]); } },
 { text: '近30天', onClick(picker) { picker.$emit('pick', [dayjs().subtract(29, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]); } },
 ]
 }
 };
 },
 computed: {
 overviewCards() {
 const o = this.overview;
 return [
 { label: '总访问量', value: o.total_visits || 0, icon: 'el-icon-data-line', theme: 'blue', sub: `今日 ${o.today_visits || 0}` },
 { label: '独立访客', value: o.unique_visitors || 0, icon: 'el-icon-user', theme: 'green' },
 { label: '独立IP', value: o.unique_ips || 0, icon: 'el-icon-connection', theme: 'orange' },
 { label: '新访客', value: o.new_visitors || 0, icon: 'el-icon-star-on', theme: 'red' },
 ];
 }
 },
 mounted() {
 this.loadWebsite();
 this.loadAll();
 window.addEventListener('resize', this.resizeCharts);
 },
 beforeDestroy() {
 window.removeEventListener('resize', this.resizeCharts);
 Object.values(this.charts).forEach(c => c && c.dispose());
 },
 methods: {
 async loadWebsite() {
 this.loadingInfo = true;
 try {
 const res = await websiteApi.detail(this.websiteId);
 if (res.code === 0) this.website = res.data;
 } catch (e) { this.$message.error('加载网站信息失败'); }
 finally { this.loadingInfo = false; }
 },
 loadAll() {
 const [startDate, endDate] = this.dateRange || [];
 const params = { website_id: this.websiteId, start_date: startDate, end_date: endDate };
 this.loadOverview(params);
 this.loadTrend(params);
 this.loadReferer(params);
 this.loadDevice(params);
 this.loadLocationStats(params);
 this.loadFilterOptions(params);
 this.ipPage = 1;
 this.loadIp(params);
 },
 async loadOverview(params) {
 try {
 const res = await statsApi.overview(params);
 if (res.code === 0) this.overview = res.data;
 } catch (e) { console.error(e); }
 },
 async loadTrend(params) {
 try {
 const res = await statsApi.trend({ ...params, granularity: this.trendGranularity });
 if (res.code !== 0) return;
 const { labels, visits, visitors, ips, new_visitors } = res.data;
 this.renderChart('trendChart', {
 tooltip: { trigger: 'axis', backgroundColor: 'rgba(26,26,46,0.9)', borderColor: 'rgba(79,172,254,0.3)', textStyle: { color: '#fff', fontSize: 12 } },
 legend: { data: ['访问量', '独立访客', '独立IP', '新访客'], top: 5, textStyle: { fontSize: 12 } },
 grid: { left: 50, right: 25, top: 55, bottom: 60 },
 xAxis: { type: 'category', data: labels, axisLabel: { rotate: 30, fontSize: 11, color: '#8c8c8c' }, axisLine: { lineStyle: { color: '#d9d9d9' } } },
 yAxis: { type: 'value', axisLabel: { color: '#8c8c8c' }, splitLine: { lineStyle: { color: '#f0f0f0' } } },
 dataZoom: [{ type: 'inside' }, { type: 'slider', height: 20, bottom: 10, borderColor: '#e4e7ed', fillerColor: 'rgba(79,172,254,0.1)' }],
 series: [
 { name: '访问量', type: 'line', smooth: true, data: visits, itemStyle: { color: '#4facfe' }, lineStyle: { width: 2 }, areaStyle: { color: new echarts.graphic.LinearGradient(0,0,0,1,[{offset:0,color:'rgba(79,172,254,0.25)'},{offset:1,color:'rgba(79,172,254,0)'}]) } },
 { name: '独立访客', type: 'line', smooth: true, data: visitors, itemStyle: { color: '#43e97b' }, lineStyle: { width: 2 } },
 { name: '独立IP', type: 'line', smooth: true, data: ips, itemStyle: { color: '#fa8231' }, lineStyle: { width: 2 } },
 { name: '新访客', type: 'line', smooth: true, data: new_visitors, itemStyle: { color: '#fc5c65' }, lineStyle: { width: 2 } },
 ]
 });
 } catch (e) { console.error(e); }
 },
 onTrendGranularityChange() {
 const [startDate, endDate] = this.dateRange || [];
 this.loadTrend({ website_id: this.websiteId, start_date: startDate, end_date: endDate });
 },
 async loadReferer(params) {
 try {
 const res = await statsApi.referer({ ...params, limit: 10 });
 if (res.code !== 0) return;
 const data = res.data.map(item => ({ name: item.name || '直接访问', value: item.count }));
 this.renderChart('refererChart', {
 tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)', backgroundColor: 'rgba(26,26,46,0.9)', borderColor: 'rgba(79,172,254,0.3)', textStyle: { color: '#fff', fontSize: 12 } },
 legend: { type: 'scroll', bottom: 0, textStyle: { fontSize: 11 } },
 series: [{
 type: 'pie', radius: ['38%', '65%'], center: ['50%', '45%'],
 data, label: { fontSize: 11, color: '#595959' },
 itemStyle: { borderRadius: 6, borderColor: '#fff', borderWidth: 2 },
 color: ['#4facfe','#43e97b','#fa8231','#fc5c65','#a55eea','#26ade0','#fed330','#26de81','#455a64','#d9d9d9']
 }]
 });
 } catch (e) { console.error(e); }
 },
 async loadDevice(params) {
 try {
 const res = await statsApi.device(params);
 if (res.code !== 0) return;
 const { browsers, oses, devices } = res.data;
 const pieColors = ['#4facfe','#43e97b','#fa8231','#fc5c65','#a55eea','#26ade0','#fed330','#26de81'];
 const commonPie = (data, nameKey) => ({
 type: 'pie', radius: ['35%', '62%'], center: ['50%', '50%'],
 data: data.map(b => ({ name: b[nameKey], value: +b.count })),
 label: { fontSize: 11, color: '#595959', formatter: '{b}\n{d}%' },
 itemStyle: { borderRadius: 5, borderColor: '#fff', borderWidth: 2 },
 color: pieColors
 });
 this.renderChart('browserChart', { tooltip: { trigger: 'item', backgroundColor: 'rgba(26,26,46,0.9)', borderColor: 'rgba(79,172,254,0.3)', textStyle: { color: '#fff', fontSize: 12 } }, series: [commonPie(browsers, 'browser')] });
 this.renderChart('osChart', { tooltip: { trigger: 'item', backgroundColor: 'rgba(26,26,46,0.9)', borderColor: 'rgba(79,172,254,0.3)', textStyle: { color: '#fff', fontSize: 12 } }, series: [commonPie(oses, 'os')] });
 this.renderChart('deviceChart', { tooltip: { trigger: 'item', backgroundColor: 'rgba(26,26,46,0.9)', borderColor: 'rgba(79,172,254,0.3)', textStyle: { color: '#fff', fontSize: 12 } }, series: [commonPie(devices, 'device')] });
 } catch (e) { console.error(e); }
 },
 async loadIp(params) {
 try {
 const res = await statsApi.ip({ ...params, ...this.ipFilter, page: this.ipPage, page_size: this.ipPageSize });
 if (res.code === 0) { this.ipList = res.data.list; this.ipTotal = res.data.total; }
 } catch (e) { console.error(e); }
 },
 async loadLocationStats(params) {
 try {
 const res = await statsApi.locationStats({ ...params, limit: 15 });
 if (res.code !== 0) return;
 const data = res.data;
 this.renderChart('locationChart', {
 tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, backgroundColor: 'rgba(26,26,46,0.9)', borderColor: 'rgba(79,172,254,0.3)', textStyle: { color: '#fff', fontSize: 12 } },
 grid: { left: 60, right: 25, top: 25, bottom: 50 },
 xAxis: { type: 'category', data: data.map(d => d.location), axisLabel: { rotate: 35, fontSize: 11, color: '#8c8c8c', interval: 0 }, axisLine: { lineStyle: { color: '#d9d9d9' } } },
 yAxis: { type: 'value', axisLabel: { color: '#8c8c8c' }, splitLine: { lineStyle: { color: '#f0f0f0' } } },
 dataZoom: [{ type: 'inside' }, { type: 'slider', height: 20, bottom: 8, borderColor: '#e4e7ed', fillerColor: 'rgba(79,172,254,0.1)' }],
 series: [{ name: '访问次数', type: 'bar', data: data.map(d => +d.visit_count), itemStyle: { color: new echarts.graphic.LinearGradient(0,0,0,1,[{offset:0,color:'#4facfe'},{offset:1,color:'#00f2fe'}]), borderRadius: [4,4,0,0] }, label: { show: true, position: 'top', fontSize: 11, color: '#8c8c8c', formatter: '{c}' } }]
 });
 } catch (e) { console.error(e); }
 },
 async loadFilterOptions(params) {
 try {
 const res = await statsApi.device(params);
 if (res.code !== 0) return;
 this.filterOptions.browsers = res.data.browsers.map(b => b.browser).filter(Boolean);
 this.filterOptions.oses = res.data.oses.map(o => o.os).filter(Boolean);
 this.filterOptions.devices = res.data.devices.map(d => d.device).filter(Boolean);
 } catch (e) { console.error(e); }
 },
 searchIp() {
 this.ipPage = 1;
 const [startDate, endDate] = this.dateRange || [];
 this.loadIp({ website_id: this.websiteId, start_date: startDate, end_date: endDate });
 },
 resetIpFilter() {
 this.ipFilter = { ip_keyword: '', location_keyword: '', browser_filter: '', os_filter: '', device_filter: '' };
 this.ipPage = 1;
 const [startDate, endDate] = this.dateRange || [];
 this.loadIp({ website_id: this.websiteId, start_date: startDate, end_date: endDate });
 },
 handleIpPageChange(p) {
 this.ipPage = p;
 const [startDate, endDate] = this.dateRange || [];
 this.loadIp({ website_id: this.websiteId, start_date: startDate, end_date: endDate });
 },
 renderChart(ref, option) {
 this.$nextTick(() => {
 const el = this.$refs[ref];
 if (!el) return;
 if (this.charts[ref]) this.charts[ref].dispose();
 this.charts[ref] = echarts.init(el);
 this.charts[ref].setOption(option);
 });
 },
 resizeCharts() {
 Object.values(this.charts).forEach(c => c && c.resize());
 },
 formatTime(t) {
 return t ? dayjs(t).format('YYYY-MM-DD HH:mm:ss') : '-';
 }
 }
};
</script>

<style scoped>
.info-card { margin-bottom: 20px; border-radius: 12px; border: none; box-shadow: 0 2px 12px rgba(0,0,0,0.06); }
.info-card /deep/ .el-card__body { padding: 20px 24px; }

.info-header { display: flex; justify-content: space-between; align-items: center; }
.info-name { font-size: 18px; font-weight: 700; color: #1a1a2e; }
.info-meta { display: flex; gap: 16px; }
.info-tag { font-size: 13px; color: #595959; background: #f5f7fa; padding: 4px 12px; border-radius: 6px; }
.info-tag i { margin-right: 4px; color: #8c8c8c; }

.filter-bar { display: flex; align-items: center; margin-bottom: 20px; }
.card-row { margin-bottom: 20px; }
.card-row > .el-col { display: flex; }

.stat-card {
 background: #fff; border-radius: 12px; padding: 22px 24px;
 box-shadow: 0 2px 12px rgba(0,0,0,0.06); width: 100%;
 position: relative; overflow: hidden; transition: transform 0.2s, box-shadow 0.2s;
 display: flex; flex-direction: column;
}
.stat-card:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(0,0,0,0.1); }
.stat-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 4px; z-index: 1; }
.stat-card.blue::before { background: linear-gradient(90deg, #4facfe, #00f2fe); }
.stat-card.green::before { background: linear-gradient(90deg, #43e97b, #38f9d7); }
.stat-card.orange::before { background: linear-gradient(90deg, #fa8231, #ffa502); }
.stat-card.red::before { background: linear-gradient(90deg, #fc5c65, #ff6b81); }
.stat-card-top { display: flex; align-items: center; gap: 16px; }
.stat-card-icon { width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-size: 24px; flex-shrink: 0; }
.stat-card.blue .stat-card-icon { background: rgba(79,172,254,0.1); color: #4facfe; }
.stat-card.green .stat-card-icon { background: rgba(67,233,123,0.1); color: #43e97b; }
.stat-card.orange .stat-card-icon { background: rgba(250,130,49,0.1); color: #fa8231; }
.stat-card.red .stat-card-icon { background: rgba(252,92,101,0.1); color: #fc5c65; }
.stat-card-info { flex: 1; }
.stat-card-value { font-size: 30px; font-weight: 700; color: #1a1a2e; line-height: 1.2; }
.stat-card-label { font-size: 13px; color: #8c8c8c; margin-top: 2px; }
.stat-card-sub { font-size: 12px; color: #bfbfbf; margin-top: auto; padding-top: 10px; border-top: 1px solid #f5f5f5; min-height: 22px; }

.chart-card { background: #fff; border-radius: 12px; box-shadow: 0 2px 12px rgba(0,0,0,0.06); overflow: hidden; width: 100%; }
.chart-header { padding: 16px 20px; border-bottom: 1px solid #f5f5f5; display: flex; align-items: center; justify-content: space-between; }
.chart-title { font-size: 15px; font-weight: 600; color: #1a1a2e; letter-spacing: 0.5px; }
.chart-body { height: 360px; padding: 12px; }

.filter-bar-inner { display: flex; align-items: center; gap: 8px; padding: 12px 16px; border-bottom: 1px solid #f5f5f5; flex-wrap: wrap; background: #fafbfc; }
</style>